// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"80e079f4","453":"66f71256","732":"cff1a3bf","977":"0ba2a9a3"}[chunkId] + ".chunk.js";
};